import React from 'react'

import { Link, useNavigate } from 'react-router-dom'
import '../Style.css'


export const FailPagesWithdrawal = () => {

    const navigate = useNavigate()

    setTimeout(()=>{
        navigate('/wallet',{replace: true})
    },3000)

  return (
    <div>
        <div>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-5">
                        <div className="message-box _success _failed">
                            <i className="fa fa-times-circle" aria-hidden="true"></i>
                            <h2> Your Withdrawal failed </h2>
                            <p>  Try again later </p> 
                            <Link to={'/wallet'} >wallet</Link>
                        </div> 
                    </div> 
                </div> 
            </div>
        </div>
    </div>
  )
}
